<svc-dialog-primary
  *environment="let env"
  #dialog
  dialogStyle="empty"
  [fullscreen]="['XS', 'SM']"
  class="overflow-hidden"
>
  <svc-registry-modal-header svc-dialog-title>
    {{ 'Alerta' | transloco }}
  </svc-registry-modal-header>

  <div
    #dialogContent
    svc-dialog-content
    class="flex flex-col h-full"
  >
      @if (isSaveLoading) {
        <div class="fadeIn flex-auto flex items-center justify-center py-30">
          <mat-spinner
            class="text-primary"
            diameter="30"
          />
        </div>
      }

      <div
        class="fadeIn flex-auto overflow-auto px-4 pt-6"
        [hidden]="isSaveLoading || isInitialLoading"
      >
        <div #topInfo>
          <div class="mb-[26px]">
            <p class="text-[11px] text-default mb-2">
              {{ 'Número' | transloco }}
            </p>

            <p
              class="text-default text-base font-medium"
              [class.mx-2]="!isViewMode"
              [class.mt-2.5]="!isViewMode"
            >
              {{ 'ALE' | transloco }}-{{ formAlert?.controls.alertId.value }}
            </p>
          </div>
        </div>

        <nav
          class="w-full border-b"
          mat-tab-nav-bar
          mat-stretch-tabs="false"
          mat-align-tabs="center"
          [tabPanel]="tabPanel"
        >
          <div
            mat-tab-link
            [active]="tabIndex === 0"
            (click)="tabIndex = 0"
          >
            {{ 'Alerta' | transloco }}
          </div>
          <div
            *ngIf="showTabActionPlan || isShowTabActionPlanLoading"
            mat-tab-link
            [active]="tabIndex === 1"
            (click)="!isShowTabActionPlanLoading && (tabIndex = 1)"
            [disabled]="isShowTabActionPlanLoading"
          >
            {{ 'Plano de ação' | transloco }}

            <ng-container *ngIf="openPlans && !isShowTabActionPlanLoading">
              <mat-icon
                class="ml-3 mr-1 icon-size-3"
                svgIcon="heroicons_solid:clipboard-list"
                [class.text-primary]="tabIndex === 1"
              />

              <p class="font-normal text-base">{{ completePlans }}/{{ openPlans }}</p>
            </ng-container>
            <mat-spinner
              class="text-current ml-2"
              *ngIf="isShowTabActionPlanLoading"
              diameter="20"
            />
          </div>
          <div
            mat-tab-link
            [active]="tabIndex === 2"
            (click)="!isAddMode && (tabIndex = 2)"
            [disabled]="isAddMode"
          >
            {{ 'Feed' | transloco }}

            <ng-container *ngIf="!isAddMode && alertFeedTab?.commentsTotal >= 0">
              <mat-icon
                class="ml-2.5 mr-1 icon-size-3"
                svgIcon="heroicons_solid:chat-alt"
                [class.text-primary]="tabIndex === 2"
              />

              <p class="font-normal text-base">
                {{ alertFeedTab?.commentsTotal }}
              </p>
            </ng-container>
          </div>
        </nav>

        <mat-tab-nav-panel
          #tabPanel
          class="block py-4"
        >
          <!-- ALERT -->
          <div
            [class.hidden]="tabIndex !== 0"
            #alertTab
          >
            <form
              class="grid gap-4 sm:grid-cols-2 md:grid-cols-1"
              [formGroup]="formAlert"
            >
              <svc-highlight-group>
                <div class="grid grid-cols-2 gap-2 w-full">
                  <svc-date-picker
                    formControlName="createDate"
                    [label]="'Data de abertura' | transloco"
                    [showIcon]="false"
                  />

                  <svc-date-picker
                    formControlName="occurrenceDate"
                    [label]="'Data de ocorrência' | transloco"
                    [showIcon]="false"
                    [inputReadOnly]="true"
                    [max]="maxOccurrenceDate"
                    [dateFilter]="occurrenceDateFilter"
                  />
                </div>
              </svc-highlight-group>

              <div class="flex justify-center sm:col-span-2 md:col-span-1 overflow-hidden">
                <input
                  #inputFile
                  type="file"
                  multiple
                  hidden
                  [accept]="acceptFiles"
                  (change)="addMediaInputFile($event)"
                />

                <svc-media-carousel
                  *ngIf="!isInitialLoading"
                  [class]="midiasCarousel?.length ? 'w-full' : 'w-64'"
                  [height]="160"
                  [editMode]="!isViewMode"
                  [items]="midiasCarousel"
                  [showEmptyInViewMode]="false"
                  [playVideoWhenMouseHover]="false"
                  [showEmptyInViewMode]="false"
                  (onAddTriggered)="carouselAddTrigger = $event; inputFile.click()"
                  (onDeleteTriggered)="removeSlide($event)"
                ></svc-media-carousel>
              </div>

              <div>
                <p class="input-label-size input-label-weight text-default">
                  {{ 'Originador' | transloco }}
                </p>

                <div
                  class="flex gap-2 mt-2"
                  *ngIf="userAvatar?.name || userAvatar?.picture"
                >
                  <svc-user-avatar [info]="userAvatar" />

                  <p class="text-default text-base font-medium">
                    {{ userAvatar?.name }}
                  </p>
                </div>
              </div>

              <svc-select
                class="block"
                formControlName="teamId"
                fallbackTextValue="-"
                [label]="'Time' | transloco"
                [placeholder]="'Opcional' | transloco"
                [options]="alertCombos?.teams"
                [loading]="!isViewMode && isAllCombosLoading"
                [readonly]="isViewMode"
              />

              <svc-location-field
                #locationField
                inputId="alert-register-form-location"
                [formControl]="formAlert?.controls?.locationId"
                [readonly]="isViewMode"
              />

              <svc-chip
                class="block"
                type="single"
                formControlName="classificationId"
                fallbackTextValue="-"
                [label]="'Classificação' | transloco"
                [options]="alertCombos?.classification"
                [loading]="!isViewMode && isAllCombosLoading"
                [readonly]="isViewMode"
              />

              <svc-chip
                class="block sm:col-span-2 md:col-span-1"
                type="single"
                formControlName="failureId"
                fallbackTextValue="-"
                [label]="'Falha' | transloco"
                [options]="alertCombos?.failures"
                [loading]="!isViewMode && (isAllCombosLoading || isSaveLoading || isFailuresLoading)"
                [readonly]="isViewMode"
              />

              <svc-chip
                class="block"
                type="single"
                formControlName="materialTypeId"
                fallbackTextValue="-"
                [label]="'Tipo de material' | transloco"
                [placeholder]="'Opcional' | transloco"
                [options]="alertCombos?.materialType"
                [loading]="!isViewMode && isAllCombosLoading"
                [readonly]="isViewMode"
              />

              <svc-chip
                class="block"
                type="single"
                formControlName="productId"
                fallbackTextValue="-"
                [label]="'Material' | transloco"
                [placeholder]="'Opcional' | transloco"
                [options]="alertCombos?.materials"
                [loading]="!isViewMode && (isAllCombosLoading || isMaterialsLoading)"
                [readonly]="isViewMode"
              />

              <svc-chip
                class="block"
                type="single"
                formControlName="supplierId"
                fallbackTextValue="-"
                [label]="'Fornecedor' | transloco"
                [placeholder]="'Opcional' | transloco"
                [options]="alertCombos?.suppliers"
                [loading]="!isViewMode && isAllCombosLoading"
                [readonly]="isViewMode"
              />

              <svc-chip-grouped
                class="block"
                formControlName="hashtagIds"
                fallbackTextValue="-"
                readonlyStyle="chip"
                appearance="primary"
                [label]="'Hashtag' | transloco"
                [placeholder]="'Opcional' | transloco"
                [options]="alertCombos?.hashtags"
                [loading]="!isViewMode && isAllCombosLoading"
                [readonly]="isViewMode"
                [collapsedDisplaying]="false"
              />

              <svc-form-custom-field
                class="col-span-full"
                #customField
                [applicationId]="applicationId"
                [featureId]="featureIdAlert"
                [systemReferenceId]="alertMode?.id"
                [isViewMode]="isViewMode || isSave"
                [onlyCustomFields]="true"
              />

              <svc-audio-to-text-wrapper
                *ngIf="!isViewMode"
                class="d-block w-full overflow-hidden sm:col-span-2 md:col-span-1"
                [showVoiceToTextButton]="showVoiceToTextButton"
                [control]="formAlert?.controls?.description"
              >
                <svc-text-area
                  class="block w-full"
                  formControlName="description"
                  fallbackTextValue="-"
                  [label]="'Observações' | transloco"
                  [placeholder]="'Opcional' | transloco"
                  [minRows]="4"
                  [maxRows]="4"
                  [readonly]="isViewMode"
                />
              </svc-audio-to-text-wrapper>

              <svc-text-area
                *ngIf="isViewMode"
                class="block w-full sm:col-span-2 md:col-span-1"
                formControlName="description"
                fallbackTextValue="-"
                [label]="'Observações' | transloco"
                [placeholder]="'Opcional' | transloco"
                [minRows]="4"
                [maxRows]="4"
                [readonly]="true"
              />
            </form>
          </div>

          <!-- ACTION PLAN -->
          <div
            *ngIf="showTabActionPlan"
            [class.hidden]="tabIndex !== 1"
            #actionPlanTab
          >
            <svc-actionplan
              [id]="alertMode?.id"
              [originatorId]="alert?.originatorId || formAlert?.controls?.originatorId?.value"
              [rolesCreatePermission]="rolesCreatePermission"
              [isViewMode]="isViewMode"
              [applicationId]="applicationId"
              [legacyApplicationId]="legacyApplicationId"
              (openPlans)="openPlans = $event"
              (completePlans)="completePlans = $event"
            />
          </div>

          <!-- FEED -->
          <div
            [class.hidden]="tabIndex !== 2"
            #feedTab
          >
            <app-alert-feed-tab
              #alertFeedTab
              [alertId]="alertMode?.id"
              [isAddMode]="isAddMode"
            />
          </div>
        </mat-tab-nav-panel>
      </div>

      <div
        class="border-t flex justify-between px-4 py-2.5 w-full h-10"
        *ngIf="!isInitialLoading && !isSaveLoading && !isAddMode && tabIndex !== dialogAlertTabs.Feed && (showTabActionPlan || tabIndex !== dialogAlertTabs.ActionPlan)"
      >
        <div class="flex gap-4 items-center justify-between py-2">
          <svc-bookmark-button
            class="w-fit"
            [referenceId]="alert?.alertId"
            [applicationId]="applicationId"
            [initialValue]="alert?.isBookmarked"
            [iconAlwaysFilled]="true"
            (onValueChanged)="onBookmarkChanged($event)"
          />

          <svc-reaction
            class="flex flex-auto"
            #svcReaction
            [class]="svcReaction.hasReacted ? 'text-primary' : 'text-default'"
            [registryUniqueId]="alert?.alertId"
            [applicationId]="applicationId"
            [dontEmitFirstTime]="fromAddMode"
            [relativeFromElement]="['svc-dialog-primary .overflow-auto', 'svc-dialog-primary .overflow-auto .overflow-auto', 'body .cdk-global-overlay-wrapper']"
            positionX="left"
            (onReactionChange)="onReactionChange($event)"
            (onLoadingChange)="isReactionLoading = $event"
            (onReactionChange)="onReactionChange($event)"
            (click)="!isReactionLoading && (svcReaction.hasReacted ? svcReaction?.removeCurrentReaction() : svcReaction?.makeReactionByEnum('LIKE'))"
          >
            <mat-icon
              *ngIf="!isReactionLoading"
              class="icon-size-6 text-current"
              svgIcon="heroicons_solid:hand-thumb-up"
            />
            <ngx-skeleton-loader
              *ngIf="isReactionLoading"
              class="w-6 h-6"
              [theme]="{ width: '100%', height: '100%', borderRadius: '4px', marginBottom: 0 }"
            />
          </svc-reaction>

          <div class="flex items-center text-default">
            <mat-icon
              svgIcon="mat_solid:comment"
              class="cursor-pointer text-current icon-size-6"
              (click)="!isSaveLoading && goToFeed()"
            />
          </div>
        </div>

        <svc-totals-status
          #totalsStatus
          *ngIf="alert?.alertId && alertFeedTab?.alertFeedKey"
          class="h-fit self-end"
          [referenceId]="alert.alertId"
          [applicationId]="applicationId"
          [configTypeId]="alertFeedTab.alertFeedKey"
          [featureName]="featureName"
          [available]="{ reactions: true, comments: true, views: true }"
        />
        <ngx-skeleton-loader
          *ngIf="!alert?.alertId || !alertFeedTab?.alertFeedKey"
          class="self-end w-32 h-4"
          [theme]="{ width: '100%', height: '100%', borderRadius: '4px', marginBottom: 0 }"
        />
      </div>
    
    @if (isInitialLoading) {
      <svc-modal-alert-skeleton />
    }
    
  </div>
  <div
    svc-dialog-actions-options
    class="flex gap-2 items-center"
  >
    @if (!isInitialLoading) {
      @if (isViewMode) {
        <svc-button-ellipsis
          color="on-primary"
          [matMenuTriggerFor]="moreOptionsMenu"
          [disabled]="isSaveLoading"
        />
  
        <mat-menu xPosition="before" #moreOptionsMenu="matMenu">
          <button
            class="flex items-center gap-2"
            mat-menu-item
            (click)="print()"
          >
            <mat-icon
              class="icon-size-5"
              svgIcon="heroicons_solid:printer"
            />

            <span class="text-default text-base font-normal">
              {{ 'Imprimir' | transloco }}
            </span>
          </button>

          @if (!isAddMode && (userLoggedId === alert?.originatorId || userHasPermissionToDelete)) {
            <button
              class="flex items-center gap-2"
              mat-menu-item
              (click)="confirmDeletion(alert?.alertUniqueId)"
            >
              <mat-icon
                class="icon-size-5"
                svgIcon="heroicons_solid:trash"
              />

              <span class="text-default text-base font-normal">
                {{ 'Remover' | transloco }}
              </span>
            </button>
          }
        </mat-menu>
      }

      @if (isAddMode) {
        <button
          svc-outlined-btn
          type="button"
          id="svc-modal-alert-button-close"
          color="on-primary"
          (click)="dialogRef.close()"
        >
          {{ 'Fechar' | transloco }}
        </button>

        <button
          svc-filled-btn
          id="svc-modal-alert-button-add"
          color="on-primary"
          [disabled]="isViewMode || formAlert?.invalid"
          [processing]="isLoading"
          (click)="createOrUpdateAlert()"
        >
          {{ 'Incluir' | transloco }}
        </button>
      } @else {
        @if (userLoggedId === alert?.originatorId || userHasPermissionToEdit) {
          <button
            svc-outlined-btn
            id="svc-modal-alert-button-edit"
            color="on-primary"
            [processing]="isLoading"
            (click)="setEditMode()"
          >
            {{ (isViewMode ? 'Editar' : 'Salvar') | transloco }}
          </button>
        }

        <button
          svc-filled-btn
          type="button"
          id="svc-modal-alert-button-close"
          color="on-primary"
          (click)="dialogRef.close()"
        >
          {{ 'Fechar' | transloco }}
        </button>
      }
    }
  </div>
</svc-dialog-primary>
